import { registerTldrawLibraryVersion } from "@tldraw/utils";
import { AtomMap } from "./lib/AtomMap.mjs";
import { AtomSet } from "./lib/AtomSet.mjs";
import { devFreeze } from "./lib/devFreeze.mjs";
import { IncrementalSetConstructor } from "./lib/IncrementalSetConstructor.mjs";
import {
  createMigrationIds,
  createMigrationSequence,
  createRecordMigrationSequence,
  MigrationFailureReason,
  parseMigrationId
} from "./lib/migrate.mjs";
import {
  createEmptyRecordsDiff,
  isRecordsDiffEmpty,
  reverseRecordsDiff,
  squashRecordDiffs,
  squashRecordDiffsMutable
} from "./lib/RecordsDiff.mjs";
import { assertIdType, createRecordType, RecordType } from "./lib/RecordType.mjs";
import {
  createComputedCache,
  Store
} from "./lib/Store.mjs";
import { StoreQueries } from "./lib/StoreQueries.mjs";
import { StoreSchema } from "./lib/StoreSchema.mjs";
import {
  StoreSideEffects
} from "./lib/StoreSideEffects.mjs";
registerTldrawLibraryVersion(
  "@tldraw/store",
  "5.3.0",
  "esm"
);
export {
  AtomMap,
  AtomSet,
  IncrementalSetConstructor,
  MigrationFailureReason,
  RecordType,
  Store,
  StoreQueries,
  StoreSchema,
  StoreSideEffects,
  assertIdType,
  createComputedCache,
  createEmptyRecordsDiff,
  createMigrationIds,
  createMigrationSequence,
  createRecordMigrationSequence,
  createRecordType,
  devFreeze,
  isRecordsDiffEmpty,
  parseMigrationId,
  reverseRecordsDiff,
  squashRecordDiffs,
  squashRecordDiffsMutable
};
//# sourceMappingURL=index.mjs.map
